// extracted by mini-css-extract-plugin
module.exports = {"badgeWrapper":"az_PWb","orangeBanner":"az_QWb","corner":"az_RWb","badgeOfferContent":"az_SWb","instantSaving":"az_TWb","saveBadgeWrapper":"az_UWb"};